import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const checkReferralCodeAction = {
    ...operations,
    ...selectors,
};

export {
    checkReferralCodeAction,
};
export default {
    [namespace]: reducer,
};
